import { useState } from "react";

/**
 * ロール選択用のhooks
 */
const useRowSelect = (
  rowIds: number[],
  initialSelectedRowIds: number[] = [],
): {
  selectedRowIds: number[];
  isSelected: (rowId: number) => boolean;
  isSelectedAll: boolean;
  isIndeterminate: boolean;
  toggleSelected: (id: number) => void;
  toggleSelectedAll: () => void;
} => {
  const [selectedRowIds, setSelectedRowIds] = useState<number[]>(initialSelectedRowIds);
  const isSelected = (rowId: number) => selectedRowIds.includes(rowId);
  const isSelectedAll = rowIds.length > 0 && selectedRowIds.length === rowIds.length;
  const isIndeterminate = selectedRowIds.length > 0 && selectedRowIds.length < rowIds.length;
  const toggleSelected = (rowId: number) => {
    if (isSelected(rowId)) {
      setSelectedRowIds(selectedRowIds.filter((selectedId) => selectedId !== rowId));
    } else {
      setSelectedRowIds([...selectedRowIds, rowId]);
    }
  };
  const toggleSelectedAll = () => {
    if (isSelectedAll) {
      setSelectedRowIds([]);
    } else {
      setSelectedRowIds(rowIds);
    }
  };

  return {
    selectedRowIds,
    isSelected,
    isSelectedAll,
    isIndeterminate,
    toggleSelected,
    toggleSelectedAll,
  };
};

export default useRowSelect;
